var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDoNotUseTetrachlorethylene = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8.01 8.01",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#313332"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4 0a4 4 0 1 0 4 4 4 4 0 0 0 -4-4zm0 7.3a3.3 3.3 0 1 1 3.3-3.3 3.3 3.3 0 0 1 -3.3 3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.33 2.69h-.92a.09.09 0 0 0 -.08.08v2.58a.09.09 0 0 0 .08.08h.36a.08.08 0 0 0 .07-.08v-.92h.49a.87.87 0 1 0 0-1.74zm-.03 1.31h-.46v-.83h.46a.4.4 0 0 1 .4.38.41.41 0 0 1 -.4.45z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDoNotUseTetrachlorethylene);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "DoNotUseTetrachlorethylene.20ae368614517db4fabab6720b30f0f2.svg";